import { InjectionToken, Injectable } from '@angular/core';

@Injectable()
export class LocalizedMonthNamesService implements LocalizedMonthsGetter {
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  public getMonthName(idx) {
    return this.months[idx];
  }
}

export interface LocalizedMonthsGetter {
  getMonthName(index: number): string;
}

export const CALENDAR_LOCALIZATION_SERVICE = new InjectionToken<string>(
  'CalendarLocalizationService'
);
